import { ButtonArrow } from "@thrivetribe/mvf.assets.icons.button-arrow";
import { Button } from "@thrivetribe/mvf.ui.atoms.button";
import {
  OnboardingPage,
  OnboardingPageBody,
  OnboardingPageContent,
  OnboardingPageCopy,
} from "@thrivetribe/mvf.ui.organisms.onboarding-page";
import { sendForgottenPasswordEmail } from "helpers/sendForgotPasswordEmail";
import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import "./ForgottenPassword.scss";
import { RootState } from "redux/store";
import { ImagesUrl } from "configs/EnvironmentConfig";

export const ForgottenPasswordRequested: React.FC = () => {
  const forgottenPasswordValues = useSelector((state: RootState) => state.forgottenPassword);

  const [emailInviteSent, setEmailInviteSent] = useState(false);

  const handleSubmit = async () => {
    setEmailInviteSent(false);
    try {
      await sendForgottenPasswordEmail(forgottenPasswordValues?.email);
      setEmailInviteSent(true);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="reset-password">
      <Helmet>
        <title>Reset Password Requested - MAN v FAT</title>
      </Helmet>
      <OnboardingPage hideProfile hideSubnav image={`${ImagesUrl}/football.webp`} user={""}>
        <OnboardingPageContent centralizeContent>
          <OnboardingPageBody>
            <a href="/forgotten-password" className="back-button">
              <ButtonArrow /> Back
            </a>
            <OnboardingPageCopy>
              <h1>WE'LL SORT IT</h1>
              <p>
                If you've got an account linked to this email, we'll send you an email telling you how to reset your
                password. Click the link in the email, but don't take too long, the link expires in 10 minutes. Go!
              </p>
              <p>Can't see it? Check your spam folder.</p>
              <p>
                Still nothing? If you're sure this is the email you used to sign up, you can try again by clicking{" "}
                <Button variant="text" onClick={handleSubmit}>
                  Send instructions again
                </Button>
              </p>
              <p>
                If this isn't the email you used to sign up, or you're still having problems, contact{" "}
                <a className="support-email" href="mailto:support@manvfat.com">
                  support@manvfat.com
                </a>
                .
              </p>
              {emailInviteSent && (
                <span className="email-sent">
                  <CheckCircleOutlineIcon />
                  New reset password link on its way
                </span>
              )}
            </OnboardingPageCopy>
          </OnboardingPageBody>
        </OnboardingPageContent>
      </OnboardingPage>
    </div>
  );
};
